export default {
    owner: 'Owner',
    dependent: 'Dependent',
    birth: 'Birth: ',
    identification: 'Identification: ',
    age: 'Age: ',
    sex: 'Sex:',
    male: 'Male',
    female: 'Female',
    totalResults: ' Items found',
    selectBeneficiary: 'Select a beneficiary ',
    updateData: 'Update data',
    email: {
        textLabel: 'Email: ',
        inputLabel: 'Email',
        validation: 'Add a valid email address'
    },
    phone: {
        textLabel: 'Phone number: ',
        inputLabel: 'Phone number *',
        require: 'To continue you must update required data',
        validation: 'Add a valid phone number',
        minLength: 'The telephone number must contain between 6 and 15 digits.'
    },
    validation: {
        success: 'Successfully updated data',
        error: 'An error occurred while updating data',
        warn: 'Data entered must be valid'
    },
    notItemsFound: {
        title: 'No matches found',
        description: 'Review the terms used in the search',
        descriptionPrefix: 'or try a ',
        descriptionSufix:'new search'         
    }
}